import React, { useContext } from "react";
import Search from "../../components/CustSearch/Search";
import JCServiceAnalysis from "../../components/Charts/JCServiceAnalysis";
import JCDescription from "../../components/ServiceAnalysis/JCDescription";
import SparesSales from "../../components/ServiceAnalysis/SparesSales";
import DEFConsumption from "../../components/ServiceAnalysis/DEFConsumption";
import ServiceDetails from "../../components/ServiceAnalysis/ServiceDetails";
import Filteraccordion from "../../components/accordion/Filteraccordion";
import { FilterContext, FilterProvider } from "../../context/Filter";
import Header from "../../components/Header/Header";
import NavBar from "../../components/NevBar/Navigation";
import Vastable from "../vasUnderFleet/Vastable";
import Psfaccordian from "../../components/ChildData/Psfaccordian";
import NavButtons from "../../components/NevBar/NavButtons";
import CustomerMetricsAccordian from "../../components/psfSalesService/CustomerMetricsAccordian";
import WaterMark from "../../components/WaterMark";

const Services = (props) => {
  const { arn: parArn, childArn } = useContext(FilterContext)
  const arn = parArn || childArn
  const { open } = useContext(FilterContext)

  return (
    <>
      <WaterMark />
      <div>
        <Header heading={"Service & Spares"} />
        <div className=" mr-2 mb-2 w-full bg-white  rounded-4xl  shadow-md  rounded-[10px]  border-gray-300">
          {/* <Search /> */}
          <div className="mt-2 m-2">
            <CustomerMetricsAccordian />
          </div>
          <div className=" justify-items-center block md:flex gap-6 md:gap-3 m-1 items-center md:mt-3">
            <div
              className={`bg-white  text-black w-96 ${open ? 'md:w-[500px]' : 'md:w-1/2'
                } rounded-lg shadow-md border col-span-2`}
            >
              <JCServiceAnalysis />
            </div>

            <div
              className="bg-white mt-2 md:mt-0 text-black w-96 rounded-lg shadow-md border md:w-1/2"
              style={{ height: "310px" }}
            >
              <JCDescription />
            </div>
          </div>
          <div className=" m-1  block md:grid grid-cols-2 md:gap-2 md:mt-4 ">
            <div className="flex flex-col  gap-6 md:gap-2 w-96 md:h-full md:w-full lg:w-full">
              <div className=" ml-4 md:ml-0 p-1md:p-0  bg-white text-black  rounded-lg shadow-md border h-72 mt-2 md:mt-1 md:h-full w-full">
                <SparesSales />
              </div>
              <div className=" ml-5 md:ml-0  bg-white text-black rounded-lg shadow-md border md:h-full">
                <Vastable />
              </div>
              <div className=" ml-5 md:ml-0  bg-white text-black rounded-lg shadow-md border md:h-full">
                <DEFConsumption />
              </div>
            </div>
            <div className=" p-4 md:p-2 mt-2 md:mt-0 md:m-1  bg-white text-black rounded-lg shadow-md border md:h-full">
              <ServiceDetails />
            </div>
          </div>
        </div>
        <NavButtons />
      </div>

    </>
  );
};

export default Services;
